import React, { useCallback, useState } from "react";
import { PremiumFeaturesModal } from "./PremiumFeaturesModal";

/**
 * Manages the "Access to Börsennews Premium Features" modal locally.
 *
 * Returns the modal node (render it anywhere inside the router tree) together
 * with handlers to open/close it. State is kept local rather than in the shared
 * modal provider because the modal navigates via react-router, which the shared
 * provider sits above.
 */
export const usePremiumFeaturesModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openPremiumModal = useCallback(() => setIsOpen(true), []);
  const closePremiumModal = useCallback(() => setIsOpen(false), []);

  const premiumModal = (
    <PremiumFeaturesModal isOpen={isOpen} onClose={closePremiumModal} />
  );

  return { isOpen, openPremiumModal, closePremiumModal, premiumModal };
};
